module.exports = __webpack_public_path__ + "static/img/Samsung.59a0c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Samsung.png
// module id = 8RJA
// module chunks = 0